import { getSearchLocationUtil } from 'modules/router/utils/get-search/index.js'
import { getPathnameLocationUtil } from 'modules/router/utils/get-pathname/index.js'

export function getPathnameWithQueryLocationUtil () {
  return `${getPathnameLocationUtil()}${getSearchLocationUtil()}`
}
